module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.message.user == this.$root.user.uid) ? _c('div', {
    staticClass: "message mine",
    class: {
      first: !_vm.continuedMessage, continued: _vm.continuedMessage
    }
  }, [(_vm.showWhen) ? _c('span', {
    staticClass: "time"
  }, [_vm._v(_vm._s(_vm.dateFormat(_vm.message.createdAt, 'h:MMtt')))]) : _vm._e(), _vm._v(" "), (_vm.showWhen) ? _c('span', {
    staticClass: "date"
  }, [_vm._v(_vm._s(_vm.dateFormat(_vm.message.createdAt, 'ddd dS mmm')) + ",")]) : _vm._e(), _vm._v(" "), _c('img', {
    staticClass: "image-circle",
    attrs: {
      "src": _vm.from.profileimg
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "bubble"
  }, [_c('span', {
    staticClass: "author"
  }, [_vm._v(_vm._s(_vm.from.firstname) + ":")]), _vm._v("\n        " + _vm._s(_vm.message.content) + "\n    ")])]) : _c('div', {
    staticClass: "message notmine",
    class: {
      first: !_vm.continuedMessage, continued: _vm.continuedMessage
    }
  }, [(_vm.showWhen) ? _c('span', {
    staticClass: "date"
  }, [_vm._v(_vm._s(_vm.dateFormat(_vm.message.createdAt, 'ddd dS mmm')) + ",")]) : _vm._e(), _vm._v(" "), (_vm.showWhen) ? _c('span', {
    staticClass: "time"
  }, [_vm._v(_vm._s(_vm.dateFormat(_vm.message.createdAt, 'h:MMtt')))]) : _vm._e(), _vm._v(" "), _c('img', {
    staticClass: "image-circle",
    attrs: {
      "src": _vm.from.profileimg
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "bubble"
  }, [_c('span', {
    staticClass: "author"
  }, [_vm._v(_vm._s(_vm.from.firstname) + ":")]), _vm._v("\n        " + _vm._s(_vm.message.content) + "\n    ")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b51266d4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/chat/conversation/Message.vue
// module id = 731
// module chunks = 1